import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const adminAxios = axios.create({ baseURL: `${BACKEND_URL}/api` });
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default adminAxios;
